import {StateProvider} from "@uirouter/angularjs";
import {FeatureNames, UserConfigProvider} from "../types/UserConfig";
import {EquityPositionsView} from "./equities/EquitiesPositionViewComponent";

/** @ngInject */
export function routerConfig($stateProvider: StateProvider, userConfigProvider: UserConfigProvider) {

    if (userConfigProvider.config.features[FeatureNames.SCREEN_OPTIONS_POSITIONS_SEARCH]) {
        $stateProvider.state("positions", {
            url: "/positions",
            templateUrl: "app/positionSearch/options/positionsearch.tpl.html",
            controller: "posSearchCtrl as posSearch",
            data: {
                pageTitle: "Position Search"
            }
        });
    } else if (userConfigProvider.config.features[FeatureNames.SCREEN_EQUITY_POSITIONS_SEARCH]) {
        $stateProvider.state("positions", {
            url: "/positions",
            component: EquityPositionsView,
            data: {
                pageTitle: "Position Search"
            }
        });
    }
}
